var $ = jQuery;

import { carousel } from '../lib/carousel.js';

// Destination guides on the location and travel pages: one photo with the
// next peeking in on phones, all three side by side on wide screens.
$(document).on('ready', function(){
    $('.desitnation-swiper').each(function(){
      carousel(this, this.parentElement, {
        label: 'photo',
        slidesPerView: 1.15,
        spaceBetween: 16,
        breakpoints: {
          640: { slidesPerView: 2, spaceBetween: 20 },
          1024: { slidesPerView: 2.5, spaceBetween: 20 },
          1440: { slidesPerView: 3, spaceBetween: 20 },
        },
      });
    });
  });
